import { create } from 'zustand';

// Toasts stack instead of replacing each other (e.g. toggling several agent tools in quick
// succession); beyond this cap the oldest is dropped so the stack can't grow unbounded.
const MAX_STACK = 4;

let nextId = 0;

export const useSnackbarStore = create((set, get) => ({
	snackbars: [],

	showSnackbar: ({
		title = '',
		message,
		severity = 'success',
		showUndo = false,
		showView = false,
		onUndo = null,
		onView = null,
		autoHideDuration = 6000,
		anchorOrigin = { vertical: 'top', horizontal: 'center' }
	}) =>
		set(state => ({
			snackbars: [
				...state.snackbars,
				{
					id: ++nextId,
					title,
					message,
					severity,
					showUndo,
					showView,
					onUndo,
					onView,
					autoHideDuration,
					anchorOrigin
				}
			].slice(-MAX_STACK)
		})),

	showSuccess: (message, options = {}) => {
		const { showSnackbar } = get();
		showSnackbar({
			// Backwards-compatible: callers pass message as first arg
			message,
			severity: 'success',
			...options
		});
	},

	showError: (message, options = {}) => {
		const { showSnackbar } = get();
		showSnackbar({
			// Backwards-compatible: callers pass message as first arg
			message,
			severity: 'error',
			...options
		});
	},

	showInfo: (message, options = {}) => {
		const { showSnackbar } = get();
		showSnackbar({
			// Backwards-compatible: callers pass message as first arg
			message,
			severity: 'info',
			...options
		});
	},

	// With an id dismisses that toast; without one clears the whole stack.
	hideSnackbar: id =>
		set(state => ({
			snackbars: id === undefined ? [] : state.snackbars.filter(snack => snack.id !== id)
		}))
}));
